<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.28
        <br>2020
      </span>
      <span class="tiel">疫情无情，美菜有情！特殊时期美菜为你送菜到家</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        为最大程度降低疫情进一步蔓延的风险，少出门、少接触人流密集的场所已经成为当前所有人的共识。另一方面，由于特殊情势公众的紧张心理，各大商超生鲜区菜品每天被快速抢光售罄，个别地区甚至出现天价菜品。
        <br>
        <br>为了满足广大消费者的正常生活所需，从即日起，在特殊时期美菜决定将我们供应餐厅的平价菜品开放为个人和家庭用户进行下单配送服务。目前武汉地区已经首先开通。
        <br>
        <br>以下城市也都逐步开放：
        <br>北京、上海、深圳、苏州、南京、杭州、广州、武汉、长沙、重庆、合肥、成都、无锡、济南、青岛、天津、西安、福州、厦门、郑州、沈阳、大连、贵阳、南昌、石家庄、南宁、太原、昆明、长春、哈尔滨等，详情请登陆美菜商城查询。
        <br>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_1.png" width="640">
      </p>
      <div class="tet-js">
        <p>作为中国餐饮供应链杰出服务商，美菜长期专注为全国广大餐厅提供优质丰富的食材配送上门服务。针对餐厅的大包装规格倒也正好可以满足您全家团聚、多日囤货；简洁的包装是为了保持平价供应——试营业期间还会有种种不周之处，希望您能够包容理解。</p>
        <br>
        <p>此次特殊时期作为应急便民保障服务，我们建议您可以邀请周边邻里好友共同下单，最大程度地节约春节期间有限的运力资源，以便更多隔离在家的家庭能及时购买到新鲜的放心菜，具体配送有效区域以美菜APP或小程序上下单时有效区域说明为准。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_2.png" width="640">
      </p>
      <div class="tet-js">
        <p>经过严格安全防护的美菜司机将为您配送上门服务，限于特殊形势，只能采取隔夜送达的方式。请您提前一天下单（晚上9点前）采购齐全家的三餐所需，第二天食材将配送到您指定的地点。</p>
        <br>
        <p>为了避免接触风险，保护您和我们英勇的司机师傅共同的健康安全，请在下单时，通过APP中“订单备注”功能指明菜品放置的位置，如小区物业、居委会等地，送达后配送的美菜司机将通过电话和APP等渠道通知您及时取货。</p>
        <br>
        <p>服务过程中您有任何建议和意见，都请及时拨打我们的服务热线{{$concatPhone || '4006-135-135' }}，我们随时等待聆听来自您的宝贵建议。对于美菜而言，开放家庭配送是我们在特殊时期推出的应急服务，您的理解和任何一条建议将使我们快速优化改进，为更多人提供更好的体验和服务。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_3.png" width="640">
      </p>
      <div class="tet-js">
        <p>作为全国超过200万餐饮商户选择的大型食材配送供应商，美菜支持了建国70周年阅兵基地、进博会等大型国家级活动的食材保障，拥有近千家品类资源丰富的食材供应商合作伙伴队伍、严格的食品安全供应分拣流程和专业高效的自有配送团队，您可以放心下单。</p>
        <br>
        <p>疫情无情，美菜有情！特殊时期，让大家安全在家吃到平价、安心的菜，美菜人将竭尽所能。如果菜品满意，请对我们英勇奉献的司机小哥点赞鼓励。我们坚信，只要携手互助，消灭疫情、繁花盛开的春天很快便将来临。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
